import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-72 h-72 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-brand bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                  <Icon name="Building2" size={24} className="text-white" />
                </div>
                <span className="text-primary font-semibold text-lg">About REXFEL</span>
              </div>
              
              <h1 className="text-5xl lg:text-6xl font-bold text-foreground leading-tight">
                Strategic Investment
                <span className="text-gradient-brand block">Meets Digital Innovation</span>
              </h1>
              
              <p className="text-xl text-muted-foreground leading-relaxed max-w-2xl">
                Hamburg-based strategic investment firm representing calculated boldness—the confidence to back disruptive ideas while providing operational expertise to scale them.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                className="bg-gradient-to-r from-primary to-accent hover:from-primary/90 hover:to-accent/90"
                iconName="ArrowRight"
                iconPosition="right">

                Our Investment Philosophy
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                iconName="MapPin"
                iconPosition="left">

                Hamburg Office Tour
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-border">
              <div className="text-center">
                <div className="text-3xl font-bold text-primary counter-animate">50+</div>
                <div className="text-sm text-muted-foreground font-medium">Portfolio Companies</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary counter-animate">€2.5B</div>
                <div className="text-sm text-muted-foreground font-medium">Assets Under Management</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary counter-animate">15+</div>
                <div className="text-sm text-muted-foreground font-medium">Years Experience</div>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative z-10 rounded-brand-lg overflow-hidden shadow-brand-lg">
              <Image
                src="https://images.unsplash.com/photo-1717169196118-25d850bd5f9e"
                alt="Modern Hamburg office building with glass facade reflecting blue sky and clouds"
                className="w-full h-96 lg:h-[500px] object-cover" />

              
              {/* Overlay Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-brand p-6 shadow-brand">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                    <Icon name="MapPin" size={20} className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground">Hamburg Headquarters</h3>
                    <p className="text-sm text-muted-foreground">Speicherstadt, Hamburg, Germany</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-accent to-primary rounded-full opacity-20 animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-br from-primary to-accent rounded-full opacity-10 animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;